import { perfilHistoricoMap } from "@enums/SolicitacaoHistorico/PerfilHistorico/Index";

const PerfilHistoricoComp = ({ perfil }) => {
    return <span>{perfilHistoricoMap[perfil]}</span>;
};

export default PerfilHistoricoComp;